import { t } from '@lingui/core/macro';
import { TextArea } from '@pocketlaw/tetris';
import { useEsigning } from 'app/domains/esigning/components/EsigningProvider';
export function GroupMessageField(props) {
    const { value, disabled, onBlur, onChange } = props;
    const { submittingCreation } = useEsigning();
    const handleBlur = (event) => {
        onBlur(event.target.value);
    };
    const handleChange = (event) => {
        onChange(event.target.value);
    };
    return (<TextArea stretch value={value} onBlur={handleBlur} onChange={handleChange} disabled={submittingCreation || disabled} placeholder={t({ comment: 'Esigning group message placeholder', message: 'Add a message...' })}/>);
}
